function getRelativeUrl(baseUrl: string, url: string) {
    let urlKey = url.replace(baseUrl, "").toLowerCase();

    // remove parameters
    const index = urlKey.indexOf("?");
    if (index >= 0) {
        urlKey = urlKey.substring(0, index);
    }

    if (urlKey.startsWith("/")) {
        urlKey = urlKey.substring(1);
    }
    return urlKey;
}

function getBaseUrl(url: string) {
    const prefix = url.substring(0, 8);
    let BaseUrl = url.replace(prefix, "");

    const index = BaseUrl.indexOf("/");
    if (index >= 0) {
        BaseUrl = BaseUrl.substring(0, index);
    }

    return BaseUrl;
}

export const ApiUtil = { getRelativeUrl, getBaseUrl };
